import { mobile } from "../../../mediaQueries";

const styles = (theme) => ({
  wrap: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    maxWidth: "1150px",
    cursor: "none !important",
    margin: "auto",
    marginBottom: "50px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1100)]: {
      flexDirection: "column",
      textAlign: "center",
      justifyContent: "center",
      marginBottom: "0",
    },
  },
  h3: {
    cursor: "none !important",
    margin: "0",
    fontFamily: "Playfair Display",
    marginRight: "60px",
    fontWeight: "500",
    color: "#575452",
    fontSize: "48px",
    letterSpacing: "0.02em",
    maxWidth: "18ch",
    marginTop: "-10px",
    lineHeight: "67.2px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1100)]: {
      width: "100%",
      textAlign: "center",
      marginBottom: "12px",
      flexBasis: "50%",
      maxWidth: "100%",
      marginRight: "0px",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      fontSize: "32px",
      lineHeight: "41.5px",
      flexBasis: "100%",
    },
  },
  p: {
    cursor: "none !important",
    margin: "0",
    fontFamily: "Aktiv Grotesk",
    color: "#575452",
    fontWeight: "400",
    letterSpacing: "0.01em",
    fontSize: "1rem",
    maxWidth: "60ch",
    lineHeight: "25.6px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1100)]: {
      width: "100%",
      textAlign: "center",
      maxWidth: "100%",
      marginBottom: "30px",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      marginBottom: "0",
      fontSize: "14px",
      lineHeight: "21px",
      letterSpacing: "0.02em",
    },
  },
});

export default styles;
